const zhCN = {
  requestFail: '请求出现错误，请稍后再试！',

  orgRequestFail: '获取组织信息失败！'
}
const enUS = {
  requestFail: 'Request error, please try again later!',

  orgRequestFail: 'Request organization data failed!'
}

export default { zhCN, enUS }
